<template>
  <div class="container" v-if="rewards && rewards.length > 0">
    <div class="box">
      <div class="box-header">
        <h3 class="box-title" :style="titleCustomStyle">
          {{ title }}
        </h3>
      </div>
    </div>
    <div class="carousel">
      <swiper
        class="swiper bounty-carousel featured"
        :options="{...swiperOptions, ...carouselCustomOptions}"
        :instanceName="'bounty-carousel'"
      >
        <swiper-slide
          v-for="reward in rewards"
          class="swiper-slide"
          :key="reward.id"
        >
          <bounty
            :bounty="reward"
            :custom-style="bountyCustomStyle"
          />
        </swiper-slide>
      </swiper>
      <div
        :id="`bounty-pagination-${id}`"
        class="bounty-pagination"
        slot="pagination"
      />
      <div
        :id="`bounty-carousel-prev-${id}`"
        class="swiper-button-prev bounty-carousel-prev"
        slot="button-prev"
      ></div>
      <div
        :id="`bounty-carousel-next-${id}`"
        class="swiper-button-next bounty-carousel-next"
        slot="button-next"
      ></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {v4 as uuidv4} from 'uuid'
import Bounty from './Bounty'
import groupedRewards from '@/mixins/groupedRewards'

export default {
  name: 'BountyCarousel',
  components: {
    Bounty
  },
  mixins: [groupedRewards],
  data() {
    return {
      defaultTitle: this.$t('bounties.rewardsOverviewTitle'),
      defaultGroup: 'bounty-carousel',
      id: uuidv4(),
    }
  },
  computed: {
    swiperOptions() {
      return {
        slidesPerView: 1,
        spaceBetween: 18,
        pagination: {
          el: `#bounty-pagination-${this.id}`,
          clickable: true
        },
        navigation: {
          nextEl: `#bounty-carousel-next-${this.id}`,
          prevEl: `#bounty-carousel-prev-${this.id}`
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 3,
          },
          440: {
            slidesPerView: 2,
          },
          320: {
            slidesPerView: 1,
          }
        }
      }
    },
    carouselCustomOptions() {
      return _.get(this.data, 'style.carousel', null)
    }
  },
}
</script>

<style lang="scss" scoped>
.carousel {
  margin: 0 auto;
}

@media(max-width: 768px) {
  .carousel {
    width: calc(100% - 20px);
  }
}

.bounty-pagination {
  display: flex;
  margin-top: 30px;
  justify-content: center;
}

.swiper-slide {
  height: auto;
}

@media(max-width: 768px) {
  .carousel .swiper-button-prev {
    left: -20px;
  }
  .carousel .swiper-button-next {
    right: -20px;
  }
}
</style>
